import { BaseError, type BaseErrorParameters } from './base';

export class MfaInvalidOtpError extends BaseError {
  constructor({ cause }: Pick<BaseErrorParameters, 'cause'>) {
    super({
      cause,
      code: 'mfa_invalid_otp_error',
      docsUrl: null,
      name: 'MfaInvalidOtpError',
      shortMessage: 'Invalid OTP',
    });
  }
}
